<template>
  <div class="white">
    <v-container
      v-if="!store.currentUser"
      class="pt-0"
    >
      <v-layout
        row
        wrap
      >
        <v-flex
          id="topSpacer"
          xs12
          class="mt-5 hidden-sm-and-down"
        >
          &nbsp;
        </v-flex>
        <!-- When choosing a servicer, we need to give a little extra space -->
        <v-flex
          :class="{'pa-4': $vuetify.breakpoint.smAndDown}"
          :md6="auth_state === 'new_choose_expert'"
          md5
          xs12
          sm7
        >
          <h1
            :class="{'mb-4 display-2': $vuetify.breakpoint.mdAndUp, 'mb-3 display-1': $vuetify.breakpoint.smAndDown}"
            class="light primary--text"
          >
            {{ titleText }}
          </h1>
          <div
            v-if="subtitleText"
            class="subtitle"
          >
            {{ subtitleText }}
          </div>
          <h2
            v-if="shouldShowSubtitle"
            class="title primary--text"
          >
            {{ store.borrowerWebContent.chooseLoSubtitleText }}
          </h2>
          <v-flex
            md10
            xs12
          >
            <template v-if="state==='initial'">
              <v-text-field
                v-model="email"
                :error-messages="errorMessages"
                class="sel_email"
                label="Your Email"
                @blur="validateEmail"
                @focus="clearErrors"
                @keyup.enter="getStarted"
              />
              <v-layout
                id="continueButtons"
                row
                wrap
                class="mt-3"
              >
                <v-flex
                  :class="{'pr-2': $vuetify.breakpoint.mdAndUp}"
                  md6
                  xs12
                >
                  <v-btn
                    block
                    class="btn--xlarge primary text--white sel_button_get_started"
                    color="primary"
                    @click="getStarted"
                  >
                    Continue
                  </v-btn>
                </v-flex>
                <v-flex
                  :class="{'pl-2': $vuetify.breakpoint.mdAndUp}"
                  class="text-xs-center"
                  md6
                  xs12
                >
                  <v-btn
                    flat
                    class="mx-auto grey--text text--darken-1 btn--xlarge sel_button_sign_in"
                    @click="signIn"
                  >
                    {{ store.borrowerWebContent.onboardingAlternateActionLinkText }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </template>
            <template v-else>
              <StateFlow
                :activation-code="store.activationCode"
                :user-email="email"
                :init="'start'"
                @title="(value) => {titleText = value}"
                @subtitle="(value) => {subtitleText = value}"
                @change-activation-code="handleChangedActivationCode"
                @change-state="(value) => {auth_state = value}"
                @change-local-state="(value) => {state = value}"
              />
            </template>
          </v-flex>
        </v-flex>
        <v-flex
          v-if="auth_state !== 'new_choose_expert'"
          class="mx-2 hidden-md-and-down"
        >
          &nbsp;
        </v-flex>
        <v-flex
          v-if="auth_state !== 'new_choose_expert'"
          sm5
          md6
          class="hidden-sm-and-down ml-6 mt-0 mb-6"
        >
          <app-preview />
        </v-flex>
      </v-layout>

      <div v-if="state === 'initial'">
        <v-flex class="my-1 hidden-sm-and-down">
&nbsp;
        </v-flex>
        <hr :class="{'mb-6': $vuetify.breakpoint.mdAndUp, 'mt-3 mb-5': $vuetify.breakpoint.smAndDown}">
        <mobile-info />
      </div>

      <hr
        :class="{'mt-5': $vuetify.breakpoint.mdAndUp}"
        class="mb-5"
      >

      <v-flex
        id="contactInfo"
        md6
        offset-md3
        xs10
        offset-xs1
      >
        <contact-info />
      </v-flex>
      <v-layout
        v-if="store.servicer"
        row
      >
        <v-flex class="mb-5 grey--text text--lighten-1 body-2 text-sm-center text-xs-center">
          <borrower-footer />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import snValidationsService from '../../services/snValidationsService.js'
import statefulAuth from '../common/_statefulAuth.vue'
import appPreview from './_appPreview.vue'
import borrowerFooter from './_borrowerFooter.vue'
import contactInfo from './_contactInfo.vue'
import snServicerProfilesService from '../../services/snServicerProfilesService.js'
import mobileInfo from './_mobileInfo.vue'

export default {
  name: 'BorrowerOnboarding',

  components: {
    StateFlow: statefulAuth,
    AppPreview: appPreview,
    'borrower-footer': borrowerFooter,
    'contact-info': contactInfo,
    'mobile-info': mobileInfo
  },

  data () {
    return {
      auth_state: '',
      email: '',
      state: 'initial',
      errorMessages: [],
      titleText: 'With a little information, we\'ll save your work for you.',
      subtitleText: '',
      fieldHeader: '',
      store: this.$store
    }
  },

  computed: {
    shouldShowSubtitle () {
      if (this.auth_state === 'new_choose_expert') return true
      return false
    }
  },

  beforeUpdate () {
    this.$store.sidenav = false
  },

  created () {
    if (!this.store.borrowerWebContent || !this.store.servicer) {
      this.loadServicerInfo()
    }
    if (this.$route?.query?.email) {
      this.email = this.$route.query.email.replace(/ /g, '+')
      if (snValidationsService.email(this.email)) {
        this.state = 'flow'
      }
    }
  },

  beforeRouteEnter (to, from, next) {
    let activationCode = ''
    if (to.params.code) {
      activationCode = to.params.code
    }
    if (activationCode !== '') {
      snServicerProfilesService.getServicerProfile(activationCode).then(response => {
        const servicerData = JSON.parse(response.data.servicer_profile)
        if (servicerData.has_1003_enhanced !== true && servicerData.allow_borrower_web_signup !== true) {
          next(`/borrower/go_mobile/${activationCode}`)
        } else {
          next()
        }
      })
    } else {
      next('/borrower/signup')
    }
  },

  methods: {
    handleChangedActivationCode (newSac) {
      this.store.activationCode = newSac
      this.loadServicerInfo()
      this.$router.replace('/borrower/onboarding/' + this.store.activationCode)
    },
    loadServicerInfo () {
      this.titleText = this.store.borrowerWebContent ? (this.store.borrowerWebContent.onboardingGetStartedHeader || this.titleText) : this.titleText
      // Checks if the mockup is passed back from web content, and sets it in the store if so.
      // This is important if clients choose a different LO along the process.
      if (this.store.borrowerWebContent && Object.prototype.hasOwnProperty.call(this.store.borrowerWebContent, 'servicerMockup') && this.store.borrowerWebContent.servicerMockup !== '') {
        this.store.mockup = this.store.borrowerWebContent.servicerMockup
      }
      if (this.store.borrowerWebContent && Object.prototype.hasOwnProperty.call(this.store.borrowerWebContent, 'logoUrl') && this.store.borrowerWebContent.logoUrl !== '') {
        this.store.logoUrl = this.store.borrowerWebContent.logoUrl
      }
      snServicerProfilesService.getServicerProfile(this.store.activationCode)
        .then(response => {
          this.store.servicer = JSON.parse(response.data.servicer_profile)
          this.store.servicer.state_lics = response.data.state_licenses
          this.store.servicerLinks = response.data.links
          this.store.servicerLinkTypes = response.data.servicer_link_types
          if (this.store.servicer.has_1003_enhanced !== true && this.store.servicer.allow_borrower_web_signup !== true) {
            this.$router.replace({ path: '/borrower/go_mobile/' + this.store.activationCode })
          }
        })
    },
    getStarted () {
      if (this.validateEmail() && this.email !== '') {
        this.state = 'flow'
      } else {
        this.errorMessages = ['Please enter your email to get started']
      }
    },

    signIn () {
      // If they press the sign in button we want to redirect them to login unless they have entered their email then
      // we continue in the onboarding flow
      if (this.email === '') {
        window.location = '/borrower/login/' + this.store.activationCode
      } else {
        this.getStarted()
      }
    },

    validateEmail () {
      if (this.email !== '' && this.email !== undefined) this.email = this.email.trim()
      if (this.email === '') {
        this.clearErrors()
        return true
      } else if (!snValidationsService.email(this.email)) {
        this.errorMessages = ['Invalid Email Address']
        return false
      }
      return true
    },

    clearErrors () {
      this.errorMessages = []
    }

  }
}
</script>
<style scoped>
  .subtitle {
    color: rgba(0,0,0,.54)
  }
</style>
